import * as angular from "angular";
import {IController} from "angular";
import {ScheduleRequestsService} from "../../../schedule/services/schedule-requests.service";

export class todaysAgentsScheduleCtrl implements IController {
  agentId: any;

  public hasPermissionToView: boolean;
  public shiftsList: any;
  public loading:boolean;

  constructor(private scheduleRequestsService: ScheduleRequestsService, private moment, private $log, private IAMPermissions) {
    this.hasPermissionToView = this.IAMPermissions.hasPermission('schedule.service.list');
  }

  $onInit() {
    this.shiftsList=[];
    if (this.agentId) {
      this._setSchedule(this.agentId);
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.agentId && !changes.agentId.isFirstChange()) {
      this._setSchedule(this.agentId);
    }
  }

  private _setSchedule(agentId) {
    if (!!agentId && this.hasPermissionToView) {
      this.loading = true;
      this.scheduleRequestsService.getAgentScheduleInstancesByAgentId(
        this.moment().startOf('day').valueOf(),
        this.moment().endOf('day').valueOf(),
        undefined,
        [this.agentId])
        .then((agentShiftsListList) => {
          this.shiftsList = agentShiftsListList;
        })
        .catch((error) => {
          this.$log.error('Failed to get address by coordinates,', error)
        })
        .finally(() => {
          this.loading = false;
        })
    } else {
      this.shiftsList = [];
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('todaysAgentsSchedule', {
    bindings: {
      agentId: '<',
    },
    template: require('./todays-agents-schedule.html').default,
    controller: todaysAgentsScheduleCtrl
  });
